import "./Login.css";
import React from "react";
import FormImage from "../../Assets/images/login.png";
import { Link } from "react-router-dom";
import LoginViewModel from "./LoginViewModel";
import { ToastContainer } from "react-toastify";
import ButtonSpinner from "../../Components/Spinners/ButtonSpinner";

const Login = () => {
  const [
    User,
    setUser,
    SignInUser,
    EmailError,
    PasswordError,
    DisableForm,
    RememberMe,
    setRememberMe,
  ] = LoginViewModel();

  return (
    <div className="main-wrapper login-body">
      <ToastContainer />
      <div className="login-wrapper">
        <div className="container">
          <div className="loginbox">
            <div className="login-left">
              <img className="img-fluid" src={FormImage} alt="Logo" />
            </div>
            <div className="login-right">
              <div className="login-right-wrap">
                {/* <h1>Welcome to Preskool</h1> */}
                <h1>Welcome to SMS</h1>
                <p className="account-subtitle">
                  Need an account? <Link to="/register">Sign Up</Link>
                </p>
                <h2>Sign in</h2>
                {/* Form */}
                <form>
                  <div className="form-group">
                    <label>
                      Email <span className="login-danger">*</span>
                    </label>
                    <input
                      className={`form-control ${
                        EmailError === true && "error-message"
                      }`}
                      type="email"
                      onChange={(e) =>
                        setUser({ ...User, Email: e.target.value })
                      }
                    />

                    {EmailError === true ? (
                      <span className="login-tooltip">
                        <i className="fa-solid fa-info icon-after-submit"></i>
                        <span className="text-after-submit">
                          Email is required. xyz@gmail.com
                        </span>
                      </span>
                    ) : (
                      <span className="login-tooltip">
                        <i className="fa-solid fa-info text-info"></i>
                        <span className="login-tooltip-text">
                          Email is required. xyz@gmail.com
                        </span>
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      Password <span className="login-danger">*</span>
                    </label>
                    <input
                      className={`form-control pass-input ${
                        PasswordError === true && " error-message"
                      }`}
                      type="password"
                      onChange={(e) =>
                        setUser({ ...User, Password: e.target.value })
                      }
                    />
                    {PasswordError === true ? (
                      <span className="login-tooltip">
                        <i className="fa-solid fa-info icon-after-submit"></i>
                        <span className="text-after-submit">
                          Password is required and cannot be less than 6
                          characters
                        </span>
                      </span>
                    ) : (
                      <span className="login-tooltip">
                        <i className="fa-solid fa-info text-info"></i>
                        <span className="login-tooltip-text">
                          Password is required and cannot be less than 6
                          characters
                        </span>
                      </span>
                    )}
                  </div>
                  <div className="forgotpass">
                    <div className="remember-me">
                      <label className="custom_check mr-2 mb-0 d-inline-flex remember-me">
                        Remember me
                        <input
                          type="checkbox"
                          checked={RememberMe}
                          name="radio"
                          onChange={(e) => {
                            setRememberMe(!RememberMe);
                          }}
                        />
                        <span className="checkmark" />
                      </label>
                    </div>
                    <Link to="/forgot-password">Forgot Password?</Link>
                  </div>
                  <div className="form-group">
                    <button
                      className="btn btn-primary btn-block
                        form-submit-btn-flex"
                      disabled={DisableForm}
                      type="submit"
                      onClick={(e) => {
                        e.preventDefault();
                        SignInUser();
                      }}
                    >
                      Login &nbsp;
                      {DisableForm && <ButtonSpinner />}
                    </button>
                  </div>
                </form>
                {/* /Form */}
                <div className="login-or d-none">
                  <span className="or-line" />
                  <span className="span-or">or</span>
                </div>
                {/* Social Login */}
                <div className="social-login d-none">
                  <a href="#">
                    <i className="fab fa-google-plus-g" />
                  </a>
                  <a href="#">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a href="#">
                    <i className="fab fa-twitter" />
                  </a>
                  <a href="#">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
                {/* /Social Login */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
